module.exports = __webpack_public_path__ + "static/media/organizacion_negro.156a7fa2.svg";